export function canRenderInBrowser (filename) {
  if (filename) {
    return filename.match(/\.(png|jpe?g)$/i)
  } else {
    return false;
  }
}